const query = new URLSearchParams(location.search);

// Keep the established race overlay as the default. A battle view is opt-in
// through an explicit session selector so a missing/empty selector can never
// accidentally display the live race feed.
if (query.has("battleSession")) {
  void import("./battle2d");
} else {
  void import("./main");
}

